'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	addPx = require('@mindmup/mapjs-core/src/util/px');
mmWidgets.fn.editableTableWidget = function (options) {
	return mmWidgets.each(this, function () {
		let active;
		const activeOptions = Object.assign({}, mmWidgets.fn.editableTableWidget.defaultOptions, options),
			ARROW_LEFT = 37, ARROW_UP = 38, ARROW_RIGHT = 39, ARROW_DOWN = 40, ENTER = 13, ESC = 27, TAB = 9,
			element = this,
			editor = activeOptions.editor.css({position: 'absolute', boxSizing: 'border-box'}).addClass('hidden').appendTo(element.parent()),
			positionEditor = (active) => {
				const clientRect = active.domElements[0].getBoundingClientRect(),
					cssPosition = {
						top: addPx(clientRect.top),
						left: addPx(clientRect.left),
						width: addPx(clientRect.width),
						height: addPx(clientRect.height)
					};
				editor.css(cssPosition);
			},
			showEditor = function (select) {
				active = element.find('td:focus');
				if (active.length) {
					editor.val(active.text())
						.removeClass('error')
						.removeClass('hidden');
					activeOptions.cloneProperties.forEach(prop => {
						editor.css(prop, active.domElements[0].style[prop]);
					});

					positionEditor(active);
					editor.focus();

					if (select) {
						editor.domElements[0].select();
					}
				}
			},
			setActiveText = function () {
				const newValue = editor.val(),
					evt = mmWidgets.Event('change', {newValue, cancelable: true}),
					originalContent = active.html();
				if (active.text() === newValue || editor.hasClass('error')) {
					return true;
				}

				active.text(newValue).trigger(evt);
				if (evt.defaultPrevented) {
					active.html(originalContent);
				}
			},
			movement = function (currentWidget, keycode) {
				if (keycode === ARROW_RIGHT) {
					return currentWidget.next('td');
				} else if (keycode === ARROW_LEFT) {
					return currentWidget.prev('td');
				} else if (keycode === ARROW_UP) {
					return currentWidget.parent().prev().children().eq(currentWidget.index());
				} else if (keycode === ARROW_DOWN) {
					return currentWidget.parent().next().children().eq(currentWidget.index());
				}
				return [];
			};
		editor.on('blur', function () {
			setActiveText();
			editor.addClass('hidden');
		}).on('keydown', function (e) {
			const trg = e.target;
			if (e.which === ENTER) {
				setActiveText();
				editor.addClass('hidden');
				active.focus();
				e.preventDefault();
				e.stopPropagation();
			} else if (e.which === ESC) {
				editor.val(active.text());
				e.preventDefault();
				e.stopPropagation();
				editor.addClass('hidden');
				active.focus();
			} else if (e.which === TAB) {
				active.focus();
			} else if (trg.selectionEnd - trg.selectionStart === trg.value.length) {
				const possibleMove = movement(active, e.which);
				if (possibleMove.length > 0) {
					possibleMove.focus();
					e.preventDefault();
					e.stopPropagation();
				}
			}
		})
		.on('input paste', function () {
			const evt = mmWidgets.Event('validate', {newValue: editor.val(), cancelable: true});
			active.trigger(evt);
			if (evt.defaultPrevented) {
				editor.addClass('error');
			} else {
				editor.removeClass('error');
			}
		});

		element.on('click keypress dblclick', showEditor)
		.css('cursor', 'pointer')
		.on('keydown', function (e) {
			const possibleMove = movement(mmWidgets([e.target]), e.which);
			if (possibleMove.length > 0) {
				possibleMove.focus();
				e.stopPropagation();
				e.preventDefault();
			} else if (e.which === ENTER) {
				showEditor(false);
				e.stopPropagation();
				e.preventDefault();
			} else if (e.which === 17 || e.which === 91 || e.which === 93) {
				showEditor(true);
			}
		});

		element.find('td').prop('tabindex', 1);

		window.addEventListener('resize', function () {
			if (editor.visibleOnly().length) {
				positionEditor(active);
			}
		});
	});

};
mmWidgets.fn.editableTableWidget.defaultOptions =	{
	cloneProperties: ['padding', 'padding-top', 'padding-bottom', 'padding-left', 'padding-right', 'text-align', 'font', 'font-size', 'font-family', 'font-weight', 'border', 'border-top', 'border-bottom', 'border-left', 'border-right'],
	editor: mmWidgets('<input>')
};
